// extracted by mini-css-extract-plugin
export var downloadRadioGroup = "styles-module__downloadRadioGroup___IucA8";
export var firstSection = "styles-module__firstSection___nl_2x";
export var foot = "styles-module__foot___uPA_r";
export var section = "styles-module__section___EI6mU";
export var sliderContainer = "styles-module__sliderContainer___o7YTu";